// Subscription tier colors
// Pro = Green, Premium = Yellow

export const SUBSCRIPTION_COLORS = {
  pro: {
    badge: {
      background: '#dcfce7',
      color: '#166534'
    },
    button: {
      background: '#198754',
      color: '#ffffff'
    },
    border: '#10b981',
    shadow: 'rgba(220,252,231,0.5)'
  },
  premium: {
    badge: {
      background: '#fef3c7',
      color: '#a16207'
    },
    button: {
      background: '#fbbf24',
      color: '#78350f'
    },
    border: '#facc15',
    shadow: 'rgba(254,249,195,0.5)',
    buttonGradient: 'linear-gradient(to right, #facc15, #fb923c)'
  },
  free: {
    badge: {
      background: '#f3f4f6',
      color: '#6b7280'
    },
    border: '#e2e8f0',
    button: {
      background: '#64748b',
      color: '#ffffff'
    }
  }
};
